import React, { useContext, useEffect, useState } from 'react';
import { useNotification } from '../utils/Notification';
import TopNav from '../nav/TopNav';
import EventEditor from '../event/EventEditor';
import Modal from '../modal/Modal';
import createAxiosInstance from '../axios/axiosCustom';
import { printFullDate } from '../utils/date';
import InfiniteScroll from '../loop/InfiniteScroll';
import { useTranslation } from 'react-i18next';
import SingleCheck from '../elements/SingleCheck';
import { Store } from '../utils/Store';


function DashPage() {
  const notification = useNotification()
  const { t } = useTranslation()

  const { state } = useContext(Store)
  const { userInfo } = state
  
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [events, setEvents] = useState([])
  const [slicedEvents, setSlicedEvents] = useState([])
  const [loading, setLoading] = useState(false)
  const [hasMore, setHasMore] = useState(true)
  const [eventId, setEventId] = useState(0)

  const [totalCount, setTotalCount] = useState(0)
  const [isDeleted, setIsDeleted] = useState(0)

  const activeOpts = [
    {id: 0, label: t('active'), title: t('active')},
    {id: 2, label: t('inactive'), title: t('inactive')},
  ]

  const fetchMyEvents = async (filter) => {
    const axiosCustom = await createAxiosInstance()
    let url = '/event/?page=0&limit=999'
    
    // const resp = await axiosCustom.post(url, {filter: {userId: 'moj user'}})
    const resp = await axiosCustom.post(url, { filter })
    let data = resp ? resp.data.results : null

    parseCategories(data?.results || [])
    setTotalCount(data?.totalCount || 0)
    setEvents(data?.results || [])
    setSlicedEvents([])

    fetchMoreData()
  }

  const onCreate = () => {
    setEventId(0)
    setIsModalOpen(true)
  }

  const fetchMoreData = () => {
    if(slicedEvents.length >= events.length) {
      setHasMore(false)
      return
    }

    setLoading(true)
    setHasMore(true)

    const newItems = events.slice(slicedEvents.length, slicedEvents.length + 10)
    setSlicedEvents((prev) => [...prev, ...newItems])
    setLoading(false)
  }

  const parseCategories = data => {
    data = data.map(item => {
      let category = JSON.parse(item.category)
      item.parsedCategory = t(category.name)
      item.typeName = item.type?.name ? t(item.type.name) : '-'
      return item
    })
  }

  const callbackEditor = (action) => {
    if(action == 'cancel') {
      setIsModalOpen(false)
    }

    if(action == 'save' || action == 'delete' || action == 'archive') {
      setIsModalOpen(false)
      fetchMyEvents({isDeleted: (isDeleted || 0), user: userInfo._id})
    }
    
  }

  const onSelectEvent = (event) => {
    setEventId(event._id)
    setIsModalOpen(true)
  }

  const updDeletedFilter = (val) => {
    setIsDeleted(val)
    // console.warn('upd', val)
    if(userInfo) {
      fetchMyEvents({isDeleted: val, user: userInfo._id})
    }
  }

  
  useEffect(() => {
    fetchMoreData()
  }, [events])
  
  useEffect(() => {
    // console.warn('userInfo', userInfo)
    if(userInfo) {
      fetchMyEvents({isDeleted: 0, user: userInfo._id})
    }

  }, [userInfo])
  
  
  return (
    <>
      <TopNav />
      <div className="dash-container">
        <div className="items-container">
          <div className="list-header">
            <div className="fx fx-col wgap">
              <span className="title">{t('my_events')}</span>
              <span className="info">{t('list_of_my_events')}</span>
            </div>
            <div className="action-btns">
              <SingleCheck objKey="isDeleted" options={activeOpts} defValue={'0'} onChange={updDeletedFilter} />
              <div className="counter">
                {totalCount} {t('total')}
              </div>
            </div>
          </div>

          <InfiniteScroll className="list-items" onLoadMore={fetchMoreData} hasMore={hasMore} loading={loading} >
            {slicedEvents.map((event, key) => (
              <div key={key} className="event-item" onClick={() => onSelectEvent(event)}>
                <div className="header-item">
                  <span className="title">{event.name}</span>
                </div>
                <div className="body-item">
                  <div className="fx wgap wrap">
                    {event.from && <span className="tag fx fx-col">
                      <span className="title">{t('start')}: {printFullDate(event.from)}</span>
                      <span className="info">{t('end')}: {printFullDate(event.to)}</span>
                    </span>}
                    <span className="tag fx fx-col">
                      <span className="title">{event.parsedCategory}</span>
                      <span className="info">{event.typeName}</span>
                    </span>
                    <span className="tag">{event.location.secondary_text}</span>
                  </div>
                  <div className="right-side">
                    <div className="progress-bar-wrap-dash">
                      <div className="fx info">
                        <span>{t('participants')}</span>
                        {event.maxMember && <span>{event.participantsCount+' / '+event.maxMember}</span>}
                        {!event.maxMember && <span>{event.participantsCount}</span>}
                      </div>
                      <div className="progress-bar">
                        {event.maxMember && <div className="progress-fill" style={{ width: `calc(100% * (${event.participantsCount+' / '+event.maxMember}))` }}></div>}
                        {!event.maxMember && <div className="progress-fill" style={{ width: `90%` }}></div>}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </InfiniteScroll>  
          
          {!totalCount &&
          <div className="no-data">
            <span className="no-data-text">{t('no_events')}</span>
          </div> }
        </div>
        <div className="dash-create">
          <button className="create-bt" onClick={() => onCreate()}>+</button>
        </div>
      </div>
      <Modal isOpen={isModalOpen} className="fullscreen">
        <EventEditor id={eventId} callback={callbackEditor} />
      </Modal>
    </>
  );
}

export default DashPage
